import { View, Text, ScrollView } from "react-native";
import { Logo } from "../atoms/Logo";
import { NavigationMenu } from "../organisms/NavigationMenu";
import { LogoutButton } from "ui/atoms/button/LogoutButton";
import useLogout from "app/features/authentication/hooks/useLogout";
import { useVersion } from "app/hooks/useVersion";
import { useSelector } from "react-redux";
import { ProfileMenu } from "ui/molecules/profile/ProfileMenu";
import { RootState } from "app/services/store";

interface Props {
  className?: string;
}
export function Sidebar({ className }: Props) {
  const { logout } = useLogout();

  const { version } = useVersion();

  const currentUser = useSelector(
    (state: RootState) => state.authorisation?.user,
  );

  return (
    <View
      className={`bg-background-50 border-r border-background-200 ${className}`}
    >
      <View className="border-b border-background-200 px-8 pt-7 h-[75px]">
        <Logo />
      </View>

      <ScrollView className="flex-1" contentContainerClassName="min-h-full">
        <NavigationMenu className="flex-1" />
        <View className="pt-12 px-8">
          <ProfileMenu
            profile={currentUser}
            subtitle={currentUser?.roles
              ?.map((role) => role.display_name)
              ?.join(", ")}
          />
        </View>
        <View className="py-7 px-8">
          <LogoutButton onPress={logout} />
        </View>
        <View className="px-8 pb-2">
          <Text className="text-[10px] text-gray-400">{version}</Text>
        </View>
      </ScrollView>
    </View>
  );
}
